var React = require('react');

function LetterStripesHorizontal (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"144.556","width":"190.05","height":"1.012","key":0}),React.createElement("rect",{"x":"171.655","y":"227.601","width":"140.896","height":"1.012","key":1}),React.createElement("rect",{"x":"143.906","y":"314.173","width":"196.394","height":"1.012","key":2}),React.createElement("g",{"key":3},[React.createElement("rect",{"y":"374.914","width":"187.55","height":"1.012","key":0}),React.createElement("rect",{"x":"291.917","y":"374.914","width":"187.465","height":"1.012","key":1})])]);
}

LetterStripesHorizontal.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"479.381px","height":"375.925px","viewBox":"0 0 479.381 375.925","enableBackground":"new 0 0 479.381 375.925","xmlSpace":"preserve"};

module.exports = LetterStripesHorizontal;

LetterStripesHorizontal.default = LetterStripesHorizontal;
